import { API_URL } from '../../config';
// Fase 5.14 — `ApiError` se movió a `shared/errors/` (un tipo de error compartido, no parte del
// cliente de fetch); se re-exporta acá para no romper los imports existentes.
import { ApiError } from '../errors/ApiError';

export { ApiError };

async function request(path, options = {}) {
    const { headers, body, ...rest } = options;
    const isPlainBody = body && typeof body !== 'string' && !(body instanceof FormData);
    const res = await fetch(`${API_URL}${path}`, {
        // La sesión viaja en una cookie httpOnly, no en un header manual —
        // 'include' es necesario porque en dev
        // frontend (:5173) y backend (:3000) son orígenes distintos (fetch no manda cookies
        // cross-origin por defecto). En prod, mismo origen, 'include' sigue siendo correcto.
        credentials: 'include',
        headers: isPlainBody ? { 'Content-Type': 'application/json', ...headers } : headers,
        body: isPlainBody ? JSON.stringify(body) : body,
        ...rest,
    });

    const isJson = res.headers.get('content-type')?.includes('application/json');
    const data = isJson ? await res.json().catch(() => null) : await res.text();

    if (!res.ok) {
        throw new ApiError(data?.error || data?.message || res.statusText, res.status, data);
    }
    return data;
}

export const apiClient = {
    get: (path, opts) => request(path, { ...opts, method: 'GET' }),
    post: (path, body, opts) => request(path, { ...opts, method: 'POST', body }),
    put: (path, body, opts) => request(path, { ...opts, method: 'PUT', body }),
    patch: (path, body, opts) => request(path, { ...opts, method: 'PATCH', body }),
    del: (path, opts) => request(path, { ...opts, method: 'DELETE' }),
};
